import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { findLink } from '../../../../../../LinkyLinky';
import { Link as LinkT } from '../../../../../../Resource/Types';
import { T } from '../../../../../../Translations';
import ModalStore from '../../../../../Modal/Store';

export interface Props {
  shareModalStore: ModalStore;
  links: ReadonlyArray<LinkT>;
}

export const publishAndShareLink = ({ shareModalStore, links }: Props): Maybe<React.ReactNode> =>
  findLink('publish', links).map(() => (
    <Link
      key="Publish and Share"
      to={'#'}
      onClick={() => shareModalStore.open()}
      className="px-4 py-2.5"
      data-intercom-target="publish-and-share-action"
    >
      <T kind="Publish and Share" />
    </Link>
  ));
